const SET_OES_STEPS = "SET_OES_STEPS";
const SET_OES_STEPS_PROMISE = "SET_OES_STEPS_PROMISE";

export {
    SET_OES_STEPS,
    SET_OES_STEPS_PROMISE,
};
